export default __webpack_public_path__ + "static/media/img4.2bd96b3c.jpg";